import { Component, OnInit } from '@angular/core';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { TreeTableModule } from 'primeng/treetable';
import { MessageService, TreeNode } from 'primeng/api';
import { MockService } from '../../../services/mock.service';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';

interface Column {
  field: string;
  header: string;
  icon: string;
}
@Component({
  selector: 'app-role-indicators',
  standalone: true,
  imports: [
    NgForOf,
    TreeTableModule,
    NgIf,
    InputSwitchModule,
    ToastModule,
    CheckboxModule,
    NgClass,
  ],
  templateUrl: './role-indicators.component.html',
  styleUrl: './role-indicators.component.scss',
})
export class RoleIndicatorsComponent implements OnInit {
  cols!: Column[];
  nodes!: TreeNode[];

  //selectedNodes: TreeNode[] = []; // prime core-bug - todo - check after update
  selectedNodes: any = [];
  access = false;

  constructor(
    private nodeService: MockService,
    private messageService: MessageService
  ) {}

  /**
   * Initializes the component by fetching the category tree table nodes from the nodeService
   * and setting up the column definitions for display in a table.
   *
   * @return {void} This method does not return any value.
   */
  ngOnInit(): void {
    this.nodeService
      .getCategoryTreeTableNodes()
      .then(data => (this.nodes = data));

    this.cols = [
      { field: 'name', header: 'Name', icon: '' },
      { field: 'read', header: 'lesen', icon: 'fas fa-glasses' },
      { field: 'write', header: 'schreiben', icon: 'fas fa-pencil' },
      { field: 'add', header: 'hinzufügen', icon: 'fas fa-circle-plus' },
      { field: 'delete', header: 'löschen', icon: 'fas fa-trash' },
      {
        field: 'publish',
        header: 'veröffentlichen',
        icon: 'fas fa-earth-europe',
      },
    ];
  }

  /**
   * Toggles the `access` property between true and false.
   * Sends a notification indicating whether access has been granted or denied.
   *
   * @return {void} Does not return a value.
   */
  accessToggle(): void {
    this.access = !this.access;
    this.messageService.add(
      this.access
        ? {
            severity: 'success',
            summary: 'Aktualisiert',
            detail: 'Zugriff gewährt',
          }
        : {
            severity: 'error',
            summary: 'Aktualisiert',
            detail: 'Zugriff verweigert',
          }
    );
  }
}
